import bootstrap from 'bootstrap';
import slick from 'slick-carousel';
// import parallax from 'jquery-parallax.js';
import Cookies from 'js-cookie';
import AOS from 'aos';
import './sass/main.scss';

$(document).ready(function() {
  
  $('.slider').slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 4000,
      pauseOnHover: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
  });

  $('.rotate').slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      fade: true,
      speed: 400,
      pauseOnHover: true,
      cssEase: 'linear',
  }).hover(function(){
    $(this).slick('slickGoTo', $(this).slick("getSlick").slideCount - 1);
  });


});

AOS.init({
  easing: 'linear',
  offset: 50
});

const contactForm = document.querySelector('.offcanvas-btn');

document.addEventListener('aos:in:sg-contact-form', ({ detail } ) => {
  if( detail && !detail.classList.contains('d-none') ) {
    if( contactForm.classList.contains('hide') ) {
        contactForm.classList.remove('hide');
    } else {
      contactForm.classList.add('hide');
    }
  }
  
});

const locations = document.querySelectorAll('.map-location');
const gmap = document.querySelector('#gmap_canvas');

if( locations ) {   
  locations.forEach( location  => {
    location.addEventListener('click', e => {

      e.preventDefault();
      // let result  = e.currentTarget.dataset.address.replace(/ /g, '%20');
      let result  = e.currentTarget.getAttribute('href');
      gmap.src = `https://maps.google.com/maps?q=${result}&t=&z=13&ie=UTF8&iwloc=&output=embed`;

    }) 
  })
}

let lastScrollTop; 
let navbar = document.querySelector('.site-header'); 

window.addEventListener('scroll',function(){
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if(scrollTop > 0){ 
    navbar.classList.add('scroll');
  }
  
  else{
    navbar.classList.remove('scroll');

  }
});


let options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};

function success(pos) {
  var crd = pos.coords;
  
  Cookies.set('current_long', crd.longitude, { expires: 7, path: '/' })
  Cookies.set('current_lat', crd.latitude, { expires: 7, path: '/' })

}

function error(err) {

  if( !localStorage.getItem('location_notice') ) {
    alert('Please enable the geolocation/location in browser and reload the page.');
    localStorage.setItem('location_notice', '1');

  }

}

navigator.geolocation.getCurrentPosition(success, error, options);